import { Collapse, Typography } from 'antd';

const { Title, Paragraph } = Typography;

export function FAQ() {
  const faqs = [
    {
      key: '1',
      label: 'How is this different from Stripe?',
      children: (
        <Paragraph
          style={{
            margin: 0,
            fontSize: '15px',
            color: '#595959',
            lineHeight: 1.6,
          }}
        >
          While Stripe handles payments, iSubscribe manages your entire
          subscription infrastructure including plans, features, entitlements,
          and access control.
        </Paragraph>
      ),
    },
    {
      key: '2',
      label: 'Can I use my own payment provider?',
      children: (
        <Paragraph
          style={{
            margin: 0,
            fontSize: '15px',
            color: '#595959',
            lineHeight: 1.6,
          }}
        >
          Yes! iSubscription integrates with Stripe, PayPal, and other payment
          providers.
        </Paragraph>
      ),
    },
    {
      key: '3',
      label: 'Do you support white-label branding?',
      children: (
        <Paragraph
          style={{
            margin: 0,
            fontSize: '15px',
            color: '#595959',
            lineHeight: 1.6,
          }}
        >
          Absolutely. All widgets and customer-facing components are fully
          customizable.
        </Paragraph>
      ),
    },
    {
      key: '4',
      label: 'Can I integrate via API?',
      children: (
        <Paragraph
          style={{
            margin: 0,
            fontSize: '15px',
            color: '#595959',
            lineHeight: 1.6,
          }}
        >
          Yes, we provide REST and GraphQL APIs with comprehensive
          documentation.
        </Paragraph>
      ),
    },
    {
      key: '5',
      label: 'Does it support usage-based billing?',
      children: (
        <Paragraph
          style={{
            margin: 0,
            fontSize: '15px',
            color: '#595959',
            lineHeight: 1.6,
          }}
        >
          Yes, track API calls, compute time, or any custom metric for
          usage-based pricing.
        </Paragraph>
      ),
    },
    {
      key: '6',
      label: 'Can I self-host?',
      children: (
        <Paragraph
          style={{
            margin: 0,
            fontSize: '15px',
            color: '#595959',
            lineHeight: 1.6,
          }}
        >
          Enterprise plans include self-hosting options with full support.
        </Paragraph>
      ),
    },
  ];

  return (
    <section style={{ padding: '80px 24px', backgroundColor: '#ffffff' }}>
      <div style={{ maxWidth: 800, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '48px' }}>
          <Title
            level={2}
            style={{
              fontSize: 'clamp(24px, 3.5vw, 36px)',
              color: '#1f1f1f',
              margin: 0,
              fontWeight: 700,
            }}
          >
            Frequently Asked Questions
          </Title>
        </div>

        <Collapse
          accordion
          ghost
          expandIconPlacement="end"
          items={faqs}
          style={{
            background: '#ffffff',
            borderRadius: '12px',
            border: '1px solid #f0f0f0',
          }}
        />
      </div>
    </section>
  );
}
